import React from 'react';

import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { IconButton, Stack, Typography } from '@mui/material';
import { navigate } from 'gatsby';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { useForm } from 'react-hook-form';

import { Disclaimer } from '../../../components/Disclaimer';
import TypographyLink from '../../../components/TypographyLink';
import { ShuttleFilters, DEFAULT_SHUTTLE_FILTERS_VALUES } from '../../../domain/shuttle';
import { storeShuttleFiltersInLocalStorage } from '../utils';
import { ShuttleFilterForm } from './shuttle-filters-form';

// ********************************************************************************
// Used on the home page to allow the user to select the shuttle service
// filters. Once the form is submitted, the user is redirected to the checkout
// page.
// SEE: shuttle-filters-form.tsx
export const HomeShuttleReservation = ({ onBackClick = () => { } }) => {
  const { t } = useTranslation();

  // == State =====================================================================
  const form = useForm<ShuttleFilters>({ defaultValues: DEFAULT_SHUTTLE_FILTERS_VALUES });

  // == Handlers ==================================================================
  // NOTE: This handler is only available once the shuttle form is valid.
  const onSubmit = (values: ShuttleFilters) => {
    // TODO: Continue only if there's available shuttles.
    storeShuttleFiltersInLocalStorage(values);
    navigate('/checkout/shuttle') /*redirect to checkout*/;
  };

  // == Render ====================================================================
  return (
    <Stack gap={3}>
      <Stack direction="row" alignItems="center" gap={1}>
        <IconButton onClick={onBackClick}>
          <KeyboardBackspaceIcon sx={{ color: 'rgba(239, 96, 163, 1)' }} />
        </IconButton>
        <Typography variant="h5" component="h2" color="primary" fontWeight={700}>
          {t('shuttle_service.name')}
        </Typography>
      </Stack>
      <Typography variant="body2">
        {t('shuttle_service.use_48_bus_routes_south_california_arizona_las_vegas_CBX')}
      </Typography>
      <Disclaimer variant="notice">
        <Typography variant="body2">
          {t('shuttle_service.otay_tijuana_venture_not_TCP_PSC_no_ownership_operation_vehicles')}
        </Typography>
      </Disclaimer>

      <ShuttleFilterForm formManager={form} onSubmit={onSubmit} layout="default" />

      <Disclaimer variant="important">
        <Disclaimer.Content>
          {t('shuttle_service.schedule_verification_and_booking_advantage')}
          <br />
          <br />
          <TypographyLink underline href="/cbx-shuttle" bold>
            {t('shuttle_service.view_routes_more_details')}
          </TypographyLink>
        </Disclaimer.Content>
      </Disclaimer>
    </Stack>
  );
};
